import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { IBeneficiary, IInvoiceData } from './generic';

export interface IContractInput {
  label: string;
  placeholder?: string;
  controlName: string;
  value?: string | number | null;
  id?: string;
  mask?: string;
  currency?: boolean;
  type?: string;
  custom?: boolean;
  error?: boolean;
}

export interface IContractArrayInput {
  [key: string]: IContractInput[];
}

export interface IContractFormGroup {
  Checked: FormControl<boolean | null>;
  Chanel: FormControl<string | null>;
  CompanyId: FormControl<number | null>;
  ContractDate: FormControl<Date | null>;
  ContractId: FormControl<string | null>;
  ContractStatus: FormControl<string | null>;
  ContractType: FormControl<string | null>;
  Error: FormControl<boolean | null>;
  FinancialInstitution: FormControl<string | null>;
  Incomplete: FormControl<boolean | null>;
  Number: FormControl<string | null>;
  Status: FormControl<string | null>;
}

export interface IContractInputsForm {
  [key: string]: FormControl<string | number | null>;
}

export interface IContractDetalhes {
  imobiliaria: string;
  dtAssinatura: string;
  cnpj: string;
  dtAssinaturaNovoContrato: string;
  rede: string;
  dtRegistroContrato: string;
  banco: string;
  status: string;
  bpo: string;
  dtStatus: string;
  contrato: string;
  evento: string;
  novoContrato: string;
  fase: string;
  observacoes: string;
  carteiraCredito: string;
  cliente: string;
  dtProducao: string;
  nConsulta: string;
  fgts: number;
  valorFinanciado: number;
  produto: string;
  valorVenda: number;
  tipoVenda: string;
}

export interface IContractFinanciamento {
  statusFaturamento: string;
  nf: string;
  dtFaturamento: string;
  vgv: string;
  tipoFaturamento: string;
  porcentagemFaturado: string;
  nLote: string;
  valorFaturado: string;
}

export interface IContractBeneficiario {
  parceiros: string;
  valor: number;
  comissao: number;
  consultor: string;
  statusParcela: string;
  gerente: string;
  dtPrevRec: string;
  dtRec: string;
}

export interface IMergedForm {
  [key: string]: any;
  detalhes: FormGroup<IContractInputsForm>;
  financiamento: FormGroup<IContractInputsForm>;
  beneficiario: FormArray;
}

export interface IPatchData {
  [key: string]: any;
}

export interface IControlsFromResolver {
  [key: string]: IContractInput[];
}

export interface IBeneficiarioFormGroup {
  parceiros: FormControl<string | null>;
  valor: FormControl<number | null>;
  comissao: FormControl<number | null>;
  consultor: FormControl<string | null>;
  statusParcela: FormControl<string | null>;
  gerente: FormControl<string | null>;
  dtPrevRec: FormControl<string | null>;
  dtRec: FormControl<string | null>;
}

export interface IApprobationFormData {
  inputs: IControlsFromResolver;
  form: FormGroup<any>;
  id?: string;
  Number?: string;
  currentTab?: number;
  currentVersion?: boolean;
}

export interface IContractByNumberFormData {
  //terminar de fazer de acordo com swagger
  Number: string | number;
  Contract?: IContractByNumber;
}

export interface IContractByNumber {
  Active: boolean;
  Amount: number;
  BeneficiaryDocument?: string;
  BeneficiaryFee: number;
  BeneficiaryName: string;
  BeneficiaryType: string;
  Chanel: string;
  CompanyId?: string;
  ContractId: string;
  ContractType: string;
  CreateDate: string;
  Error?: boolean;
  FinancialInstitution: string;
  Number: string;
  Status: string;
  Invoice?: IInvoiceData;

  StageName?: string;
  ContractDate?: string;
  QueryNumber: string;
  ContractStatus?: string;
  Processed?: boolean;
  Editing?: boolean;
  Incomplete?: boolean;
  Version?: number;
  Draft?: boolean;
  Aproved?: true;
  Current?: true;
  ImportDate?: string;
  CancelPartner?: boolean;
  CancelCompany?: boolean;
  Cancel?: boolean;
  Beneficiearies?: IBeneficiary[];
}

export interface IBeneficiaryType {
  BeneficiaryTypeId: string;
  BeneficiaryType?: string;
  CompanyId?: string;
  Name: string;
}

export enum EntityEnum {
  Contract = 'Contract',
  Beneficiary = 'Beneficiary'
}

export enum BeneficiaryCardEnum {
  Router = 'Router',
  Modal = 'Modal'
}
